import React from 'react';
import { LoadingProps } from '../../interfaces/connected-components/loading';
import { connect } from 'react-redux';
import { RootState } from '../../redux/store';

/**
 * Loader component that displays a loading indicator.
 * @param {LoadingProps} loading - Loading state from Redux store.
 * @returns {JSX.Element} Loading indicator component.
 */
const Loader: React.FC<LoadingProps> = ({ loading }): JSX.Element => {
  const { isVisible } = loading || {};
  return isVisible ? (
    <div className="fixed top-0 left-0 w-full h-full z-[99999] bg-black/40 backdrop-blur-[1px] flex justify-center items-center">
      {/* Main loader circle */}
      <div className="relative w-12 h-12 rounded-full border-[3px] border-t-white border-r-white border-b-transparent border-l-transparent box-border animate-rotation">
        {/* Inner circle (simulating ::after) */}
        <div className="absolute inset-0 m-auto w-[40px] h-[40px] rounded-full border-[3px] border-t-transparent border-r-transparent border-b-primary border-l-primary box-border animate-rotationBack"></div>
        {/* Innermost circle (simulating ::before) */}
        <div className="absolute inset-0 m-auto w-[32px] h-[32px] rounded-full border-[3px] border-t-white border-r-white border-b-transparent border-l-transparent box-border animate-rotation150"></div>
      </div>
    </div>
  ) : (
    <div></div>
  );
};

const mapStateToProps = (state: RootState) => ({
  loading: state.loading,
});

export default connect(mapStateToProps, null)(Loader);
